export default __webpack_public_path__ + "static/media/location.a13e403d.svg";